<nts-string-text-box 
    #stringTextBox 
    [showErrorTooltip]="showErrorTooltip"
    [showErrorBorder]="showErrorBorder"
    [softDisable]="true" 
    [propertyViewModel]="propertyViewModel" 
    [tabIndex]="tabIndex"
    [updateOnBlur]="true">
</nts-string-text-box>
